import { z } from 'zod'
import { oc } from '@orpc/contract'
import { actorOverrideSchema, threadPathSchema } from './assistant-conversation.contract'

export const assistantList = oc
  .route({ method: 'GET', path: '/v2/assistant/conversations' })
  .input(z.object({ actor: actorOverrideSchema }).optional())
  .output(
    z.object({
      conversations: z.array(
        z.object({
          conversationId: z.string(),
          createdAt: z.string(),
          // Present on patient-pinned conversations (in-call rail) — lets
          // callers find "my conversations about this patient".
          context: z.object({ patientId: z.string() }).optional(),
          // Nested sub-agent threads spawned within this conversation, each
          // addressable by its full threadPath. Populated only in debug mode;
          // empty otherwise.
          threads: z.array(
            z.object({
              threadPath: threadPathSchema,
              agentId: z.string(),
            }),
          ),
        }),
      ),
    }),
  )
